module.exports = __webpack_public_path__ + "img/D-email-icon-b.e50d9ee9.svg";